import SearchIcon from "@mui/icons-material/Search";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import { Grid, TableCell, Typography } from "@mui/material";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ATTLogo from "../../../assets/icons/AT&TLogo";
import BestBuyLogo from "../../../assets/icons/BestBuyLogo";
import EditIco from "../../../assets/icons/EditIco";
import MacysLogo from "../../../assets/icons/MacyssLogo";
import TargetLogo from "../../../assets/icons/TargetLogo";
import CommonButton from "../../../component/Button";
import CommonTextField from "../../../component/Input";
import CommonLinearProgress from "../../../component/Linearprogress";
import { getColor } from "../../../utils/constants";
import CommonTable from "../../candidates/Table";
import {
  DotColor,
  StatusChange,
} from "../../common-components/StyledComponents";
import FilterDialog from "./FilterDialogBox";
import { CustomDiv } from "../../chat-bot/style";

export default function AccessTeamFit() {
  const navigate = useNavigate();
  const [filterPopup, setFilterPopup] = useState(false);
  const [titleValue, setTitleValue] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState();
  const [editDialogData, setEditDialogData] = useState(null);

  const headerData = [
    { name: "ID" },
    { name: "Company" },
    { name: "Team" },
    { name: "Status" },
    { name: "Created By" },
    { name: "Fit Percentage" },
    "",
  ];

  const data = [
    {
      req_id: "31571",
      comapny: "AT&T",
      logo: <ATTLogo />,
      team: "Leadership",
      status: "Active",
      client: "Best Buy",
      created_by: "Jane Cooper",
      score: "80",
    },
    {
      req_id: "31572",
      comapny: "Optum",
      logo: <EditIco color={"#DDCFCF"} />,
      team: "Digital Marketing",
      status: "Active",
      client: "Best Buy",
      created_by: "Olivia",
      score: "50",
    },
    {
      req_id: "31573",
      comapny: "Macys",
      logo: <MacysLogo />,
      team: "Leadership",
      status: "Active",
      client: "Best Buy",
      created_by: "Esther Howard",
      score: "35",
    },
    {
      req_id: "31574",
      comapny: "Target",
      logo: <TargetLogo />,
      team: "Chat bot Development",
      status: "Active",
      client: "Best Buy",
      created_by: "Mathew",
      score: "60",
    },
    {
      req_id: "31575",
      comapny: "JC Penny",
      logo: <EditIco color={"#DDCFCF"} />,
      team: "Business Development",
      status: "Active",
      client: "Best Buy",
      created_by: "Brooklyn Simm...",
      score: "90",
    },
    {
      req_id: "31576",
      comapny: "NRG",
      logo: <EditIco color={"#DDCFCF"} />,
      team: "NA Insurance Business Development",
      status: "Active",
      client: "Best Buy",
      created_by: "Jenny Wilson",
      score: "35",
    },
    {
      req_id: "31577",
      comapny: "Best Buy",
      logo: <BestBuyLogo />,
      team: "Finance Team ",
      status: "Active",
      client: "Best Buy",
      created_by: "Robert Fox",
      score: "20",
    },
    {
      req_id: "31578",
      comapny: "Mayo Clinic",
      logo: <EditIco color={"#DDCFCF"} />,
      team: "E-Commerce Mobile App Development",
      status: "Active",
      client: "Best Buy",
      created_by: "Jacob Jones",
      score: "80",
    },
  ];
  const limit = 10;
  const sortItem = ["Req ID", "Status", "Hourly Rate", "Created"];

  const handleFilterClick = () => {
    setFilterPopup(true);
  };

  const handleClose = () => {
    setFilterPopup(false);
  };

  const handleEditClick = (row) => {
    setEditDialogData(row); // Set the clicked row data
  };

  const handleDialogClose = () => {
    setEditDialogData(null); // Reset the state to close the dialog
  };

  const DropDownData = [
    {
      id: 10,
      value: "Ten",
    },
    {
      id: 20,
      value: "Twenty",
    },
    {
      id: 30,
      value: "Thirty",
    },
  ];

  const handleTitleChange = (event) => {
    setTitleValue(event.target.value);
  };
  const handleIconClick = (row) => {
    navigate(`/access-team-fit/view?id=${row.req_id}&title=${row.team}`);
  };
  const handleTableBodyData = (row, index) => {
    if (!row) return null;

    return (
      <>
        <TableCell>{row.req_id || "-"}</TableCell>
        <TableCell>
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            {row.logo ? (
              typeof row.logo === "object" ? (
                <div style={{ width: "30px", height: "30px" }}>{row.logo}</div>
              ) : (
                <img
                  src={row.logo}
                  alt={`${row.comapny} logo`}
                  style={{
                    width: "30px",
                    height: "30px",
                    objectFit: "contain",
                  }}
                />
              )
            ) : (
              <span
                style={{
                  width: "30px",
                  height: "30px",
                  display: "inline-block",
                  backgroundColor: "#f0f0f0",
                }}
              />
            )}
            <span>{row.comapny || "-"}</span>
          </div>
        </TableCell>

        <TableCell>{row.team || "-"}</TableCell>
        <TableCell>
          <StatusChange>
            <DotColor
              color={
                row.status === "Active"
                  ? "green"
                  : row.status === "Hold"
                  ? "orange"
                  : "#667085"
              }
            />
            {row.status || "-"}
          </StatusChange>
        </TableCell>
        {/* <TableCell>{row.client || "-"}</TableCell> */}
        <TableCell>{row.created_by || "-"}</TableCell>
        <TableCell align="left">
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: "10px",
              alignItems: "center",
            }}
          >
            <CommonLinearProgress
              variant="determinate"
              value={row.score}
              flex={1}
              height={"8px"}
              borderRadius={"4px"}
              barbackgroundColor={getColor(row.score)}
            />
            <Typography> {row.score}%</Typography>
          </div>
        </TableCell>

        <TableCell>
          <VisibilityOutlinedIcon
            onClick={() => handleIconClick(row)}
            style={{ cursor: "pointer" }}
          />
        </TableCell>
      </>
    );
  };

  return (
    <CustomDiv padding="2rem">
      <Grid container alignItems="center">
        <Grid item xs={6} display="flex" alignItems="center">
          <Typography variant="h2">Jigsaw</Typography>
        </Grid>

        <Grid
          item
          xs={6}
          display="flex"
          justifyContent="flex-end"
          alignItems="center"
          sx={{ gap: 2 }}
        >
          <CommonTextField placeholder="Search" startIcon={<SearchIcon />} />
          <CommonButton
            variant="outlined"
            color="#344054"
            border="#D0D5DD"
            fontWeight="600"
            value="Filters"
            onClick={() => handleFilterClick()}
          />

          <CommonButton
            variant="contained"
            color="white"
            background="#7F56D9"
            fontWeight="600"
            value="Add New"
            onClick={() => navigate("/access-team-fit/create")}
          />
        </Grid>
      </Grid>
      <CommonTable
        data={data}
        columns={headerData}
        sortedColumns={sortItem}
        onSortChange={(col) => console.log("Sort by", col)}
        handleTableBodyData={handleTableBodyData}
        paginationProps={{
          count: totalPage,
          page: currentPage,
          onPageChange: (page) => setCurrentPage(page),
        }}
        withPagination={true}
      />

      {editDialogData && (
        <FilterDialog
          handleTitleChange={handleTitleChange}
          DropDownData={DropDownData}
          titleValue={titleValue}
          handleClose={handleClose}
          filterPopup={filterPopup}
        />
      )}
    </CustomDiv>
  );
}
